
// import APIKeyUsageTable from "../../Components/ApiKeyUsageTable.jsx";
import SimpleFooter from "../../Components/SimpleFooter.jsx";
// import SubscriptionBilling from "../../Components/SubscriptionBilling.jsx";
import SubscriptionTable from "../../Components/SubscriptionTable.jsx";
import useUserSubscription from "./useUserSubscription.js";
import {
  ArrowPathIcon,
  KeyIcon,
} from '@heroicons/react/24/outline';



export default function UserSubscription() {
  // Dummy Data
  const apiUsage = 3500;
  const apiLimit = 5000;
  const usagePercent = (apiUsage / apiLimit) * 100;
  const alertsCount = 4;
useUserSubscription()
  return (
    <>
    <div className="p-4">
      {/* <h1 className="text-2xl font-semibold mb-4">Subscriptions</h1> */}
      <SubscriptionTable />
    </div>
    <SimpleFooter/>
    </>
  );
}
